// CONTINUE TRANSACTION
export const CONTINUE_TRANSACTION = "CONTINUE_TRANSACTION";
export const CONTINUE_TRANSACTION_SUCCESS = "CONTINUE_TRANSACTION_SUCCESS";
export const CONTINUE_TRANSACTION_FAILURE = "CONTINUE_TRANSACTION_FAILURE";

// CONTINUE VERIFICATION
export const CONTINUE_VERIFICATION = "CONTINUE_VERIFICATION";
export const CONTINUE_VERIFICATION_SUCCESS = "CONTINUE_VERIFICATION_SUCCESS";
export const CONTINUE_VERIFICATION_FAILURE = "CONTINUE_VERIFICATION_FAILURE";

// TRANSACTION STATUS
export const TRANSACTION_STATUS = "TRANSACTION_STATUS";
export const TRANSACTION_STATUS_SUCCESS = "TRANSACTION_STATUS_SUCCESS";
export const TRANSACTION_STATUS_VERIFY = "TRANSACTION_STATUS_VERIFY";
export const TRANSACTION_STATUS_FAILURE = "TRANSACTION_STATUS_FAILURE";
export const TRANSACTION_STATUS_PENDING = "TRANSACTION_STATUS_PENDING";

//RFP
export const SET_RFP_MONITORING = "SET_RFP_MONITORING";

// MISCELLANEOUS
export const SET_PARAMS = "SET_PARAMS";
export const SHOW_LOADING = "SHOW_LOADING";
export const HIDE_LOADING = "HIDE_LOADING";
export const PUSH_ERROR_MESSAGE = "PUSH_ERROR_MESSAGE";
